<script>
  import { useNavigate } from "svelte-navigator";
  export let cardlogo;
  export let cardtitle;
  export let cardtext;
  export let cardlink;
  const navigate = useNavigate();
  $$restProps;
</script>

<div
  class="card"
  on:click={() => {
    navigate(cardlink);
  }}
  on:keydown={() => {
    navigate(cardlink);
  }}
>
  <div class="card-logo"></div>
  <svelte:component this={cardlogo} style="height:83px; width:60px" />

  <div class="card-body" style="overflow-y: auto">
    <h4 class="card-title bold">{cardtitle}</h4>
    <p class="card-text">{cardtext}</p>
  </div>
  <div class="card-footer" style="background: inherit; border-color: inherit;">
    <slot />
  </div>
</div>

<style>
  .card {
    padding: 1rem;
    margin: 1rem;
    width: 250px;
    aspect-ratio: 1/1;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;
    background-color: white;
    border-radius: 1rem;
    transition: 300ms ease-in-out;
  }

  .card:hover {
    box-shadow: 0px 0px 10px #d9d9d9;
  }

  .card-title {
    padding-bottom: 1rem;
    text-transform: none;
  }

  .card-text {
    min-height: 100px;
    font-size: 0.8rem;
    text-transform: none;
  }
</style>
